import { Icons, ExternalLink, Stack, tokens } from '@cast/design-system';

import { HpaSettingsBanner } from './HpaSettingsBanner';
import { useVersionsInfo } from '../_hooks/useVersionsInfo';

import { getDocsLink } from '@cast/utils';

export const HpaVersionOutdatedMessage = () => {
  const { castAgentCurrentVersion, nativeHpaSupportedFromVersion } =
    useVersionsInfo();

  return (
    <HpaSettingsBanner
      testId="hpa-version-outdated-message"
      hexIcon={{
        Icon: <Icons.Warning weight="fill" />,
        size: 50,
        iconColor: tokens.theme.fg.status.onWarningSubtle,
        hexColor: tokens.theme.bg.status.warningSubtle,
      }}
      title="Workload Autoscaler version outdated"
      description={
        <Stack alignItems="center" gap={4}>
          <span>
            Current version {castAgentCurrentVersion} is outdated. HPA v2
            features require version {nativeHpaSupportedFromVersion} or higher.
          </span>
          <ExternalLink
            link={getDocsLink('docs_woop_hpa')}
            sx={{ typography: 'P12R' }}
          >
            Documentation
          </ExternalLink>
        </Stack>
      }
    />
  );
};
